var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconNotResult(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.461,
    height: 34.105,
    viewBox: "0 0 26.461 34.105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-not_result",
    transform: "translate(-1.264 -1.26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_69",
    "data-name": "\\u30D1\\u30B9 69",
    d: "M698.225,213.116h2.709a1.452,1.452,0,0,1,1.452,1.452v12.706",
    transform: "translate(-679.846 -206.511)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_70",
    "data-name": "\\u30D1\\u30B9 70",
    d: "M35.77,239.613H25.191a1.452,1.452,0,0,1-1.452-1.452V214.568a1.452,1.452,0,0,1,1.452-1.452H27.9",
    transform: "translate(-21.725 -206.511)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_71",
    "data-name": "\\u30D1\\u30B9 71",
    d: "M206.268,26.441h-1.442a.916.916,0,0,1-.887-.684,2.707,2.707,0,0,0-5.237,0,.916.916,0,0,1-.887.684h-1.442a1.155,1.155,0,0,0-1.155,1.155v1.33a1.155,1.155,0,0,0,1.155,1.155h9.9a1.155,1.155,0,0,0,1.155-1.155V27.6A1.155,1.155,0,0,0,206.268,26.441Z",
    transform: "translate(-189.043 -21.725)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_72",
    "data-name": "\\u30D1\\u30B9 72",
    d: "M412.879,100.543a.863.863,0,1,0-.863.863.863.863,0,0,0,.863-.863",
    transform: "translate(-399.739 -95.827)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_76",
    "data-name": "\\u7DDA 76",
    x2: 11.789,
    transform: "translate(6.407 18.131)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_77",
    "data-name": "\\u7DDA 77",
    x2: 11.789,
    transform: "translate(6.407 13.316)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_78",
    "data-name": "\\u7DDA 78",
    x2: 5.766,
    transform: "translate(6.407 27.83)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_79",
    "data-name": "\\u7DDA 79",
    x2: 8.174,
    transform: "translate(6.407 22.956)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_446",
    "data-name": "\\u6955\\u5186\\u5F62 446",
    cx: 5.771,
    cy: 5.771,
    r: 5.771,
    transform: "translate(15.432 23.073)",
    fill: "none",
    stroke: "#f39628",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_73",
    "data-name": "\\u30D1\\u30B9 73",
    d: "M684.365,1068.385l2.324,2.42,4-4",
    transform: "translate(-666.322 -1039.488)",
    fill: "none",
    stroke: "#f39628",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotResult);
export default __webpack_public_path__ + "static/media/icon-not_result.b0bf30de33917cd7cf4cd6b8258f93a1.svg";
export { ForwardRef as ReactComponent };